var _path, _path2, _polygon, _polygon2, _path3, _polygon3, _rect, _rect2, _rect3, _path4, _polygon4, _path5, _path6, _path7, _polygon5, _rect4, _rect5, _path8, _path9, _polygon6, _polygon7, _circle, _circle2, _circle3, _circle4, _rect6, _path10, _path11, _polyline, _path12, _path13, _path14, _path15, _path16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompetant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1025.41029,
    height: 728.99787,
    viewBox: "0 0 1025.41029 728.99787",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M645.74148,25.03104l-27.89984,7.69651s-12.69021,1.30498-1.92413,37.52047c10.76608,36.21549,18.61043,105.78641,54.77931,112.17555,36.16888,6.38914,64.99759-75.61714,64.99759-75.61714l-89.95293-81.77539Z",
    fill: "#090814"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M522.77825,294.93836l108.9549-19.4761-5.61635,37.2572-99.37331,8.22455c-3.8827,5.45454-10.48251,9.5814-18.4173,10.79127-13.88383,2.11695-26.55901-5.48139-28.31099-16.97146-1.75194-11.49008,8.08273-22.52062,21.9666-24.63757,7.93483-1.20988,15.46461.76278,20.79644,4.81212Z",
    fill: "#ffb6b6"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "679.21758 162.16122 668.35991 162.16122 661.8453 172.48637 606.07837 281.81363 631.68877 319.06494 668.35991 281.70837 679.21758 162.16122",
    fill: "#923392"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "679.21758 162.16122 668.35991 162.16122 661.8453 172.48637 606.07837 281.81363 631.68877 319.06494 668.35991 281.70837 679.21758 162.16122",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M730.06054,43.49111c-13.08478-28.4689-46.77076-40.94021-75.23985-27.85535-28.46909,13.08487-40.94041,46.77085-27.85563,75.23975,10.61176,23.08828,34.77345,35.65146,58.71321,32.59727l8.99778,13.70374-27.50175,106.06528,58.73798-58.49209,31.3435-65.68276s-17.39942-8.93446-30.52933-21.99146c9.66729-15.62479,11.58224-35.63865,3.33409-53.58437Z",
    fill: "#ffb6b6"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "899.62831 260.43351 908.31445 474.32964 719.39096 474.32964 719.39096 258.32038 899.62831 260.43351",
    fill: "#d6d6e3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 148.76697,
    y: 333.32058,
    width: 26.90304,
    height: 392.00888,
    fill: "#d6d6e3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 261.27061,
    y: 333.32058,
    width: 26.90304,
    height: 392.00888,
    fill: "#d6d6e3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 579.21568,
    y: 333.32058,
    width: 26.90304,
    height: 392.00888,
    fill: "#d6d6e3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M686.69855,368.9742l-179.66874,50.73915s-55.47836,11.60301-25.88648,78.77736,32.40109,157.43624,32.40109,157.43624l29.31571,1.08577s31.05017-99.28581-5.42884-179.69446c0,0,179.46834,2.43444,203.56416-15.75266s30.80836-40.86443,10.33197-75.99466c-20.47639-35.13023-64.62887-16.59672-64.62887-16.59672Z",
    fill: "#090814"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "744.36361 132.31299 682.47488 227.31761 692.24678 145.34219 664.01684 212.11687 706.34646 379.8679 749.79244 374.43906 744.36361 132.31299",
    fill: "#090814"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M764.4503,415.69821l-75.68155-164.15602,59.39504-123.57227,24.9591,12.69535s38.44917,12.77318,20.10023,61.13681c-18.34894,48.36363-8.83932,119.25621,5.97172,130.27882,14.81104,11.02261,38.54473,46.15834,38.54473,46.15834,0,0-5.44977,31.79027-73.28928,37.45897Z",
    fill: "#923392"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M713.41924,383.1252l-51.57394,1.08577,17.37227-66.82242-26.05841-35.23969s-23.24778-25.20204-9.46393-51.82704l13.807-25.80532,14.06337-42.10849,21.76694-20.32312-17.37227,85.23272,37.45897,155.80759Z",
    fill: "#923392"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M769.85341,366.52847l-179.66874,50.73915s-55.47836,11.60301-25.88648,78.77736,32.40109,157.43624,32.40109,157.43624l29.31571,1.08577s31.05017-99.28581-5.42884-179.69446c0,0,179.46834,2.43444,203.56416-15.75266,24.09582-18.1871,30.80836-40.86443,10.33197-75.99466-20.47639-35.13023-64.62887-16.59672-64.62887-16.59672Z",
    fill: "#090814"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "490.72537 308.16603 647.22611 310.3788 653.74071 319.06494 342.57489 319.43802 490.72537 308.16603",
    fill: "#090814"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 691.71932,
    y: 336.83794,
    width: 26.90304,
    height: 381.16495,
    fill: "#d6d6e3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 148.76697,
    y: 345.54924,
    width: 550.28955,
    height: 19.56585,
    fill: "#d6d6e3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M661.8453,467.27215s-25.70729,37.11992,80.34677,39.6305,167.75102-10.85767,167.75102-10.85767c0,0,16.86224-16.4595-1.62865-27.2258-18.49089-10.7663-48.96862-18.67138-91.20444-8.60451s-155.2647,7.05749-155.2647,7.05749Z",
    fill: "#d6d6e3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M738.18822,499.63031v11.71366l24.09055-.09825s9.33901,8.33607,34.20167,8.14325c24.86265-.19281,23.34399-7.05749,23.34399-7.05749l53.75788-.98751v-16.92764l-135.39408,5.21398Z",
    fill: "#d6d6e3"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "780.19985 504.05761 780.19985 698.95384 815.48136 698.95384 815.48136 503.37628 780.19985 504.05761",
    fill: "#d6d6e3"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "686.81795 690.73415 686.81795 703.70031 895.82812 703.70031 895.82812 689.58534 686.81795 690.73415",
    fill: "#d6d6e3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 855.58332,
    cy: 712.41957,
    r: 9.78293,
    fill: "#d6d6e3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 894.71502,
    cy: 712.41957,
    r: 9.78293,
    fill: "#d6d6e3"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 689.27359,
    cy: 712.41957,
    r: 9.78293,
    fill: "#d6d6e3"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 728.40529,
    cy: 712.41957,
    r: 9.78293,
    fill: "#d6d6e3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 97.40661,
    y: 318.64619,
    width: 657.90173,
    height: 26.90304,
    fill: "#d6d6e3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M343.18019,320.44471c-3.22433,0-6.08734-2.05344-7.12408-5.10999l-38.24264-112.76606c-.78274-2.30744-.42464-4.77228.98164-6.76204s3.60998-3.14956,6.0462-3.18247l148.68016-2.00264h.00215c3.1882,0,6.01007,1.9361,7.12229,4.81664l43.13834,111.76653c.8965,2.32389.61424,4.84168-.77415,6.908-1.38768,2.06632-3.61177,3.27978-6.10165,3.32915l-153.72826,3.00289Z",
    fill: "#923392"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M578.46011,309.59148l108.9549-19.4761-5.61635,37.2572-99.37331,8.22455c-3.8827,5.45454-10.48251,9.5814-18.4173,10.79127-13.88383,2.11695-26.55901-5.48139-28.31099-16.97146-1.75194-11.49008,8.08273-22.52062,21.9666-24.63757,7.93483-1.20988,15.46461.76278,20.79644,4.81212Z",
    fill: "#ffb6b6"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "770.51357 219.93345 714.23594 321.99556 681.44219 325.42458 665.95879 293.63709 688.72041 275.15106 728.62459 172.24838",
    fill: "#923392"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M595.46218,626.7092l.28002,45.72191-23.26186,38.79802s-23.75092,1.42722-21.05251,14.68385l60.49493-.25197,16.71431-26.34616-.83737,26.34819,17.29797-1.0789.7161-44.20204s-4.05149-18.57155-14.63883-19.92527l-9.85861-38.74133-25.85415,4.99369Z",
    fill: "#090814"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M510.47408,626.7092l.28002,45.72191-23.26186,38.79802s-23.75092,1.42722-21.05251,14.68385l60.49493-.25197,16.71431-26.34616-.83737,26.34819,17.29797-1.0789.7161-44.20204s-4.05149-18.57155-14.63883-19.92527l-9.85861-38.74133-25.85415,4.99369Z",
    fill: "#090814"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M1019.8175,728.99787H5.51476c-3.28642-.14495-5.7146-1.79374-5.50178-3.69016-.21281-1.87628,2.21537-3.52508,5.50178-3.67003h1014.30273c2.89568.20534,5.18082,1.52599,5.53667,3.19492.46401,2.04137-1.99906,3.8955-5.53667,4.16527Z",
    fill: "#ccc"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M617.84164,32.72755s62.60229-89.20711,137.57507,26.93778c0,0,34.92587,10.6436,62.53412,47.14111s9.57279,147.35308-44.25492,155.85428c0,0,22.94212-94.6877-7.858-113.52349-30.80012-18.83578-77.44939-74.40631-77.44939-74.40631l-.79729.32743-60.12897-27.89984-9.62063-14.43095Z",
    fill: "#090814"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M382.26086,92.0166c-5.67728,9.72746-30.91019,35.24022-40.25966,41.40993-35.76218,23.5994-24.02307-10.53909-35.65855-28.18176-1.17176-1.7767-4.96853-5.64245-7.47679-5.17624-5.59826,1.04054-59.34493,65.42338-79.36904,81.66959-1.75174,1.42124-6.62662.51125-7.47679,2.87569,8.64648,31.34225,24.85171,75.21115,32.20773,104.67511.6785,2.71765-.63371,10.49665,1.15028,16.10386l36.23369,1.72541c10.62254,22.61962-7.55278,16.81892-30.48231,17.25414-20.68942.3927-41.57285-1.33141-62.1149-1.15028-4.28717-24.02984,10.17491-14.00807,41.40993-17.82928l-34.50828-127.68063c14.87167-12.08018,80.28588-74.27273,86.2707-82.81987,1.39228-1.98838.84363-6.27253,2.87569-8.62707,19.56491,12.51539,1.93017.42237.57514-2.87569-.1784-.43423-.6041-9.21723,3.45083-4.6011-10.30172-39.65907,40.01727-7.38089,64.99059-14.37845,35.0508,9.38211,39.95106,7.44099,28.18176,27.60662Z",
    fill: "#090814"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetant);
export default __webpack_public_path__ + "static/media/competant.3592301b7f38517dc0b835a3fe2766a2.svg";
export { ForwardRef as ReactComponent };